import queryString from 'query-string';
import { QRCodeURLs } from '../api/types';

export const getQueryParam = (urlQueryString: string, queryParamName: string): string | null => {
    const parameters = queryString.parse(urlQueryString);
    const paramValue = parameters[queryParamName];

    return Array.isArray(paramValue) ? paramValue[0] : paramValue;
};

export const getValueFromQr = (c: string, qrCodesData: QRCodeURLs, invalidQRError: string) => {
    if (!qrCodesData) throw new Error(invalidQRError);
    const code = c.trim();

    const temporaryBadgeNonceFound = code.startsWith(qrCodesData.temporaryBadge);
    const accessPointCodeUrl = code.startsWith(qrCodesData.accessPoint);
    const visitorNonceFound = code.startsWith(qrCodesData.visitorBadge);

    if (temporaryBadgeNonceFound) {
        const urlQueryString = code.replace(`${qrCodesData.temporaryBadge}?`, '');
        const nonce = getQueryParam(urlQueryString, 'nonce');
        if (nonce) {
            const lastAmpersandSuffix = nonce.slice(-1) === '&';
            return lastAmpersandSuffix ? { nonce: nonce.slice(0, -1) } : { nonce };
        }
    }

    if (accessPointCodeUrl) {
        const urlQueryString = code.replace(`${qrCodesData.accessPoint}?`, '');
        const accessPointCode = getQueryParam(urlQueryString, 'acp_code');
        if (accessPointCode) return { accessPointCode };
    }

    if (visitorNonceFound) {
        const urlQueryString = code.replace(`${qrCodesData.visitorBadge}?`, '');
        const visitorNonce = getQueryParam(urlQueryString, 'nonce');
        if (visitorNonce) return { visitorNonce };
    }

    throw new Error(invalidQRError);
};
